/**
 * Handles negative modulo in javascript
 *
 * @see https://stackoverflow.com/questions/4467539/javascript-modulo-gives-a-negative-result-for-negative-numbers
 *
 * @param n
 * @param m
 * @return {number}
 */
export function modulo(n, m) {
	return ((n % m) + m) % m;
}


// WEBPACK FOOTER //
// ./helpers/Math.js